import { useState } from "react";
import "../Styles/Gallery.css";
import { useConfig } from "../../context/ConfigContext";

export default function GalleryTab() {
  const { config } = useConfig();
  const uploadUrl = config.REACT_APP_GALLERY_UPLOAD_URL;
  const apiKey = config.REACT_APP_API_KEY;
  const DELETE_URL = config.REACT_APP_GALLERY_DELETE_URL;

  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [captions, setCaptions] = useState({});
  const [resultMsg, setResultMsg] = useState("");
  const [uploading, setUploading] = useState(false);
  const [openSection, setOpenSection] = useState("gallery");

  const toggleSection = (name) => {
    setOpenSection((prev) => (prev === name ? null : name));
  };

  // For deleting images
  const [deleteName, setDeleteName] = useState("");

  const onChoose = (e) => {
    const list = Array.from(e.target.files || []);
    setFiles(list);
    setPreviews(
      list.map((f) => ({
        name: f.name,
        url: URL.createObjectURL(f),
      }))
    );

    // Initialize captions
    const newCaps = {};
    list.forEach((f) => (newCaps[f.name] = ""));
    setCaptions(newCaps);
  };

  const upload = async () => {
    if (!files.length) return;

    setUploading(true);
    setResultMsg("");

    try {
      const fd = new FormData();
      files.forEach((f) => fd.append("files", f));

      // append captions object
      fd.append("captions", JSON.stringify(captions));

      const res = await fetch(uploadUrl, {
        method: "POST",
        headers: { "Api-Key": apiKey },
        body: fd, credentials: "include"
      });

      if (!res.ok) throw new Error("Upload failed");

      setResultMsg("Upload complete.");
      setFiles([]);
      setPreviews([]);
      setCaptions({});
    } catch (e) {
      console.log(e);
      setResultMsg("Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  const deleteImage = async () => {
    if (!deleteName.trim()) return;
    try {
      const res = await fetch(DELETE_URL, {
        method: "DELETE",
        headers: {
          "Api-Key": apiKey,
          "Content-Type": "application/json",
          "Image": deleteName
        },
        body: JSON.stringify({ name: deleteName }),
        credentials: "include"
      });

      const data = await res.json();

      if (res.ok) {
        setResultMsg(`Deleted: ${deleteName}`);
      } else {
        setResultMsg(data.error || "Delete failed.");
      }
    } catch (err) {
      setResultMsg("Error deleting image.");
    }
  };

  return (
    <div className="card-grid">
      <section className="card">
        <h2 className="dropdown-header" onClick={() => toggleSection("gallery")}>
          🖼️ Upload / Manage Gallery
          <span className={`chevron ${openSection === "gallery" ? "open" : ""}`}>
            ▼
          </span>
        </h2>

        {openSection === "gallery" && (
          <div className="uploader">
            <label className="drop">
              <input type="file" accept="image/*,video/*" multiple onChange={onChoose} />
              <span>Drag & drop or click to choose files</span>
            </label>

            {previews.length > 0 && (
              <div className="images-scroll">
                {previews.map((p) => (
                  <div className="row">
                  <figure key={p.name} className="thumb">
                    <img src={p.url} alt={p.name} />
                    <figcaption>
                      <input
                        className="input caption-input"
                        placeholder="Add caption/comment"
                        value={captions[p.name] || ""}
                        onChange={(e) =>
                          setCaptions((c) => ({ ...c, [p.name]: e.target.value }))
                        }
                      />
                    </figcaption>
                  </figure>
                  </div>
                ))}
                {resultMsg && <p className="muted" role="status">{resultMsg}</p>}
                        <div className="actions">
              <button className="btn primary" onClick={upload} disabled={uploading || !files.length}>
                {uploading ? "Uploading…" : "Upload"}
              </button>
            </div>
              </div>
            )}

            
          </div>
        )}
      </section>

      {/* DELETE IMAGE SECTION */}
      <section className="card">
        <h2 className="dropdown-header" onClick={() => toggleSection("delete")}>
          🗑️ Delete Image
          <span className={`chevron ${openSection === "delete" ? "open" : ""}`}>
            ▼
          </span>
        </h2>

        {openSection === "delete" && (
          <div className="form-row">
            <p className="muted small">Enter the image file name as stored in the gallery.</p>
            <input
              className="input"
              placeholder="Filename to delete (e.g. 1711301409123-photo.jpg)"
              value={deleteName}
              onChange={(e) => setDeleteName(e.target.value)}
            />

            <button className="btn danger" onClick={deleteImage}>
              Delete Image
            </button>

            {resultMsg && <p className="muted" role="status">{resultMsg}</p>}
          </div>
        )}
      </section>
    </div>
  );
}